/**
 * ABExperiment 数据表格外层状态封装（loading / 空态 / 是否已计算引导）
 */
import React from 'react';
import { useIntl } from 'umi';
import Loading from '@/pages/dashboard/components/Loading';
import NoData from '@/pages/datalab/pages/Multidimensional/Analysis/components/GuideOperation/NoData';

interface IStateContentProps {
  isLoading?: boolean;
  isEmpty?: boolean;
  /** 是否已调用过计算接口（未计算展示操作指引，计算过无数据展示无数据组件） */
  hasCalculated?: boolean;
  children: React.ReactNode;
}

const StateContent: React.FC<IStateContentProps> = (props) => {
  const {
    isLoading,
    isEmpty,
    hasCalculated = false,
    children
  } = props;

  const { formatMessage } = useIntl();

  if (isLoading) {
    return <Loading content={formatMessage({ id: 'common_loading' })} />;
  }

  // 未计算过：展示操作指引；计算过但无数据：仅展示无数据（是否计算过由计算接口是否执行完判断）
  if (isEmpty) {
    const neverCalculated = !hasCalculated;
    return (
      <>
        {neverCalculated ? (
          <NoData
            title={formatMessage({ id: 'dbl_ab_experiment_empty_guide_title' })}
            one={formatMessage({ id: 'dbl_ab_experiment_empty_guide_step1' })}
            two={formatMessage({ id: 'dbl_ab_experiment_empty_guide_step2' })}
            three={formatMessage({ id: 'dbl_ab_experiment_empty_guide_step3' })}
          />
        ) : (
          <NoData />
        )}
      </>
    );
  }

  return children;
};

export default StateContent;

